<template>
  <van-overlay :show="show" @click="clickClose">
    <div class="contain-bg">
      <div class="contain" @click.stop="">
        <div class="top-bg">
          <div class="top">
            <div class="dot dot1"></div>
            <div class="title">{{ title }}</div>
            <div class="dot dot2"></div>
          </div>
        </div>
        <div class="center-bg">
          <div class="price-bg">
            <div class="price">{{ price }}</div>
            <div v-if="lotteryType != 1" class="unit">{{ unit }}</div>
          </div>
          <div class="rule-title">{{ desc }}</div>
        </div>
        <div class="bottom-bg">
          <div class="button" @click="clickCommitJoin">
            <div>立即使用</div>
            <div class="arrow-bg">
              <van-icon name="arrow" size="8" color="rgb(252, 52, 31)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
<script>
import { Icon, Overlay } from "vant"
export default {
  name: "sevensuccessPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    lotteryType: 0,
    title: "",
    price: 0,
    unit: "",
    desc: ""
  },
  data() {
    return {}
  },
  methods: {
    clickClose() {
      this.$emit("close")
    },
    clickCommitJoin() {
      this.$emit("commitUse")
    }
  }
}
</script>
<style lang="less" scoped>
.van-overlay {
  z-index: 11;
}
.contain-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .contain {
    margin-top: -40%;
    width: 185px;
    height: 222px;
    border-radius: 7px;
    // background-color: rgb(254, 240, 222);
    background-image: url("../../../assets/img/lottery/seven/seven_success_bg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .top-bg {
      display: flex;
      justify-content: center;
      align-items: center;
      .top {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 24px;
        background-color: rgb(255, 224, 187);
        border-bottom-left-radius: 9px;
        border-bottom-right-radius: 9px;
        .title {
          font-size: 14px;
          margin: 0 15px;
          color: rgb(228, 122, 80);
        }
        .dot {
          width: 3px;
          height: 3px;
          border-radius: 1.5px;
          background-color: rgb(228, 122, 80);
        }
        .dot1 {
          margin-left: 15px;
        }
        .dot2 {
          margin-right: 15px;
        }
      }
    }
    .center-bg {
      display: flex;
      flex-direction: column;
      align-items: center;
      .price-bg {
        margin-top: 12px;
        display: flex;
        justify-content: center;
        align-items: baseline;
        .price {
          height: 60px;
          line-height: 100%;
          color: rgb(252, 52, 31);
          font-size: 67px;
        }
        .unit {
          margin-left: -4px;
          text-align: center;
          background-color: rgb(248, 0, 0);
          width: 18px;
          height: 18px;
          border-radius: 9px;
          color: rgb(254, 234, 208);
          font-size: 14px;
        }
      }
      .rule-title {
        color: rgb(228, 122, 80);
        font-size: 16px;
      }
    }
    .bottom-bg {
      margin-top: 42px;
      display: flex;
      justify-content: center;
      .button {
        background-image: linear-gradient(
          to bottom,
          rgb(255, 88, 52),
          rgb(253, 43, 24)
        );
        width: 146px;
        height: 38px;
        border-radius: 12px;
        color: rgb(255, 241, 227);
        font-size: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        .arrow-bg {
          margin-left: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 15px;
          height: 15px;
          text-align: center;
          background-image: linear-gradient(
            to bottom,
            rgb(255, 240, 221),
            rgb(255, 213, 164)
          );
          border-radius: 7.5px;
        }
      }
    }
  }
}
</style>